import { render, staticRenderFns } from "./CourseMessage.vue?vue&type=template&id=7d98f1f9&scoped=true&"
import script from "./CourseMessage.vue?vue&type=script&lang=js&"
export * from "./CourseMessage.vue?vue&type=script&lang=js&"
import style0 from "./CourseMessage.vue?vue&type=style&index=0&id=7d98f1f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d98f1f9",
  null
  
)

export default component.exports